import { queryOptions } from "@tanstack/react-query";
import { getMe, getProviders } from "./api";

/** The signed-in user (null: no session). The route guard and the headers read it. */
export const meQuery = () =>
	queryOptions({
		queryKey: ["auth", "me"] as const,
		queryFn: ({ signal }) => getMe(signal),
		staleTime: 5 * 60_000,
		retry: false,
	});

export const providersQuery = () =>
	queryOptions({
		queryKey: ["auth", "providers"] as const,
		queryFn: ({ signal }) => getProviders(signal),
		staleTime: Number.POSITIVE_INFINITY,
	});
